import styled from 'styled-components';

export const HomeContainer = styled.div `
    width: 100%;
    position: relative;

    @media only screen and (min-device-width: 800px) {
        min-width: 1200px;
    }
`